import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/es';
import axios from 'axios';
import './Slider.css';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, Scrollbar } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const API_URL = 'https://radioital.com/api/public/api/noticias';

const Noticias = () => {
  const [newst, setNews] = useState(null);
  //shuffle(slides);
  
  useEffect(() => {
    axios.get(API_URL, {
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then((res) => setNews(res.data.data));
  }, []);

  useEffect(() => {
    if(newst != null){
      new Swiper('.sliderN', {
        autoplay:{
            delay: 7500,
            pauseOnMouseEnter: true,
            disableOnInteraction: true,
        },
        modules:[Autoplay, Pagination, Navigation, Scrollbar],
        direction: 'horizontal',
        loop: true,
        spaceBetween: 10,
        slidesPerView: 1,
        breakpoints: {
            // when window width is >= 768px
            768: {
              slidesPerView: 1,
            }
        },
        scrollbar: {
            dragClass: 'swiper-scrollbar-drag',
            el: '.ns',
            draggable: true,
        },
        navigation: {
          nextEl: '.nn',
          prevEl: '.np',
        },
      });
    }
  });
  if(newst){
    return (
      <div className="sliderN swiper">
        <div className="swiper-wrapper">
          {newst.map((sld, indexqr) => (
              <div className="swiper-slide" key={indexqr}>
                  <h3>{sld.titulo_ntca}</h3>
                  <div className='content-slider'>
                    <img alt={sld.titulo_ntca} src={'/news/' + sld.imgn_ntca} />
                  </div>
                  <p className='news_body'>{sld.dscrpcncrta_ntca.substr(0, 120)}...</p>
                  <Link className="btn_cntct" to={"/news/"+sld.key_ntca}>Leer nota</Link>
              </div>
          ))}
        </div>
        <div className="swiper-button-prev np"></div>
        <div className="swiper-button-next nn"></div>
        <div className="swiper-scrollbar ns"></div>
      </div>
    );
  }
};

export default Noticias;
